import {useMapsLibrary} from '@vis.gl/react-google-maps'
import {useEffect, useRef, useState} from 'react'

type GeocodeResult = {
    latitude: number
    longitude: number
    formattedAddress: string
}

export function useGeocoder() {
    const geocodingLibrary = useMapsLibrary('geocoding')
    const [geocoder, setGeocoder] = useState<google.maps.Geocoder | null>(null)

    useEffect(() => {
        if (!geocodingLibrary) {
            return
        }
        setGeocoder(new geocodingLibrary.Geocoder())
    }, [geocodingLibrary])

    async function geocodeAddress(address: string): Promise<GeocodeResult | null> {
        if (!geocoder || !address.trim()) {
            return null
        }

        return new Promise((resolve) => {
            geocoder.geocode(
                {address, componentRestrictions: {country: 'us'}},
                (results, status) => {
                    if (status !== 'OK' || !results?.[0]?.geometry?.location) {
                        resolve(null)
                        return
                    }
                    const location = results[0].geometry.location
                    resolve({
                        latitude: location.lat(),
                        longitude: location.lng(),
                        formattedAddress: results[0].formatted_address,
                    })
                },
            )
        })
    }

    return {geocodeAddress, isReady: geocoder != null}
}
